export const HOURS = {
  "12AM": "12AM",
  "1AM": "1AM",
  "2AM": "2AM",
  "3AM": "3AM",
  "4AM": "4AM",
  "5AM": "5AM",
  "6AM": "6AM",
  "7AM": "7AM",
  "8AM": "8AM",
  "9AM": "9AM",
  "10AM": "10AM",
  "11AM": "11AM",
  "12PM": "12PM",
  "1PM": "1PM",
  "2PM": "2PM",
  "3PM": "3PM",
  "4PM": "4PM",
  "5PM": "5PM",
  "6PM": "6PM",
  "7PM": "7PM",
  "8PM": "8PM",
  "9PM": "9PM",
  "10PM": "10PM",
  "11PM": "11PM",
};

export const HOURS_WITH_LABELS = {
  [HOURS["1AM"]]: { hour: 1, label: "1 AM" },
  [HOURS["2AM"]]: { hour: 2, label: "2 AM" },
  [HOURS["3AM"]]: { hour: 3, label: "3 AM" },
  [HOURS["4AM"]]: { hour: 4, label: "4 AM" },
  [HOURS["5AM"]]: { hour: 5, label: "5 AM" },
  [HOURS["6AM"]]: { hour: 6, label: "6 AM" },
  [HOURS["7AM"]]: { hour: 7, label: "7 AM" },
  [HOURS["8AM"]]: { hour: 8, label: "8 AM" },
  [HOURS["9AM"]]: { hour: 9, label: "9 AM" },
  [HOURS["10AM"]]: { hour: 10, label: "10 AM" },
  [HOURS["11AM"]]: { hour: 11, label: "11 AM" },
  [HOURS["12PM"]]: { hour: 12, label: "12 PM" },
  [HOURS["1PM"]]: { hour: 13, label: "1 PM" },
  [HOURS["2PM"]]: { hour: 14, label: "2 PM" },
  [HOURS["3PM"]]: { hour: 15, label: "3 PM" },
  [HOURS["4PM"]]: { hour: 16, label: "4 PM" },
  [HOURS["5PM"]]: { hour: 17, label: "5 PM" },
  [HOURS["6PM"]]: { hour: 18, label: "6 PM" },
  [HOURS["7PM"]]: { hour: 19, label: "7 PM" },
  [HOURS["8PM"]]: { hour: 20, label: "8 PM" },
  [HOURS["9PM"]]: { hour: 21, label: "9 PM" },
  [HOURS["10PM"]]: { hour: 22, label: "10 PM" },
  [HOURS["11PM"]]: { hour: 23, label: "11 PM" },
  [HOURS["12AM"]]: { hour: 24, label: "12 AM" },
};

export const DAY_OF_WEEK = {
  MONDAY: "MONDAY",
  TUESDAY: "TUESDAY",
  WEDNESDAY: "WEDNESDAY",
  THURSDAY: "THURSDAY",
  FRIDAY: "FRIDAY",
  SATURDAY: "SATURDAY",
  SUNDAY: "SUNDAY",
};

export const MONTH = {
  JANUARY: "JANUARY",
  FEBRUARY: "FEBRUARY",
  MARCH: "MARCH",
  APRIL: "APRIL",
  MAY: "MAY",
  JUNE: "JUNE",
  JULY: "JULY",
  AUGUST: "AUGUST",
  SEPTEMBER: "SEPTEMBER",
  OCTOBER: "OCTOBER",
  NOVEMBER: "NOVEMBER",
  DECEMBER: "DECEMBER",
};

/**
 *
 * @param {string} month value of MONTH object
 * @returns number from 1 to 12
 */
export const getMonthNumber = (month) =>
  Object.values(MONTH).indexOf(month) + 1;

export const TIME_PERIOD = {
  AM_PEAK: "AM_PEAK",
  PM_PEAK: "PM_PEAK",
  OFFPEAK: "OFFPEAK",
};

export const HOURS_PER_YEAR = 8760;
export const SECONDS_PER_HOUR = 3600;

export const ALLOWED_DAY_TYPES = {
  WEEKDAY_ONLY: "WEEKDAY_ONLY",
  WEEKDAY_AND_WEEKEND: "WEEKDAY_AND_WEEKEND",
};
